import { useEffect, useState } from 'react'

/**
 * A media query as state, for the rare figure whose GEOMETRY changes with the viewport rather than
 * its layout. CSS is the right tool for everything else — reach for this only when the alternative
 * is rendering the same drawing twice and hiding one copy.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  )

  useEffect(() => {
    const list = window.matchMedia(query)
    const update = () => setMatches(list.matches)
    update()
    list.addEventListener('change', update)
    return () => list.removeEventListener('change', update)
  }, [query])

  return matches
}
